	export enum QueueStatusEnum {
		New = 1,
		Scheduled = 2,
		Rejected = 3
	}
